import tTable from './table.vue';

export default {
  install(instance: any) {
    instance.component('tTable', tTable);
  },
};
